import { Temporada, TemporadaJSON } from '../Temporada/Temporada';

export interface AperturaAptoFisicoXTemporadaJSON {
  aapft_id: string;
  aapft_fecha_desde_registrados: Date | null;
  aapft_fecha_hasta_registrados: Date | null;
  aapft_fecha_desde_nuevos: Date | null;
  aapft_fecha_hasta_nuevos: Date | null;
  aapft_activo: boolean;
  aapft_temid: string;
  temporada: TemporadaJSON | null;
}

export class AperturaAptoFisicoXTemporada {
  protected constructor(
    private id: string,
    private fechaDesdeRegistrados: Date,
    private fechaHastaRegistrados: Date,
    private fechaDesdeNuevos: Date,
    private fechaHastaNuevos: Date,
    private activo: boolean,
    private temid: string,
    private temporada: Temporada | null
  ) {}

  static createFrom(
    id: string,
    fechaDesdeRegistrados: Date,
    fechaHastaRegistrados: Date,
    fechaDesdeNuevos: Date,
    fechaHastaNuevos: Date,
    activo: boolean,
    temid: string,
    temporada: Temporada | null
  ) {
    return new this(
      id,
      fechaDesdeRegistrados,
      fechaHastaRegistrados,
      fechaDesdeNuevos,
      fechaHastaNuevos,
      activo,
      temid,
      temporada
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: AperturaAptoFisicoXTemporada) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: AperturaAptoFisicoXTemporadaJSON) {
    return AperturaAptoFisicoXTemporada.createFrom(
      entity.aapft_id,
      entity.aapft_fecha_desde_registrados ? new Date(entity.aapft_fecha_desde_registrados) : new Date(),
      entity.aapft_fecha_hasta_registrados ? new Date(entity.aapft_fecha_hasta_registrados) : new Date(),
      entity.aapft_fecha_desde_nuevos ? new Date(entity.aapft_fecha_desde_nuevos) : new Date(),
      entity.aapft_fecha_hasta_nuevos ? new Date(entity.aapft_fecha_hasta_nuevos) : new Date(),
      entity.aapft_activo,
      entity.aapft_temid,
      entity.temporada ? Temporada.fromJSON(entity.temporada) : null
    );
  }

  getId(): string {
    return this.id;
  }

  getTemid(): string {
    return this.temid;
  }

  getTemporada(): Temporada | null {
    return this.temporada;
  }

  getFechaDesdeRegistrados(): Date {
    return this.fechaDesdeRegistrados;
  }

  getFechaHastaRegistrados(): Date {
    return this.fechaHastaRegistrados;
  }

  getFechaDesdeNuevos(): Date {
    return this.fechaDesdeNuevos;
  }

  getFechaHastaNuevos(): Date {
    return this.fechaHastaNuevos;
  }

  getActivo(): boolean {
    return this.activo;
  }
}
